import axios from 'axios';
import { userAuthService } from './userAuth.services';

const privateFetcher = axios.create();
privateFetcher.interceptors.request.use((config) => ({
  ...config,
  headers: {
    ...config.headers,
    ...(userAuthService.isUserValidated()
      ? {
          authorization: `Bearer ${userAuthService.getValidatedUserToken()}`,
        }
      : {}),
  },
}));

export { privateFetcher };
